import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames/bind';
function Card({ header, children, style, className, headerClassName, tagLevel, isLoading }) {
    const CustomTag = `h${tagLevel}`;
    return (
        <div
            className={cx(`card card-default ${className}`, { whirl: isLoading })}
            style={style}
        >
            {/* <h4 className={cx(`card-header text-center mt-2 ${headerClassName}`)}>{header}</h4> */}
            <div className={cx(`card-header text-center ${headerClassName}`)}>
                <CustomTag>{header}</CustomTag>
            </div>
            <div className="card-body">{children}</div>
        </div>
    );
}

export default Card;

Card.propTypes = {
    header: PropTypes.string,
    children: PropTypes.node.isRequired,
    style: PropTypes.object,
    className: PropTypes.string,
    headerClassName: PropTypes.string,
    tagLevel: PropTypes.number,
    isLoading: PropTypes.bool,
};

Card.defaultProps = {
    header: '',
    style: {},
    className: '',
    headerClassName: '',
    tagLevel: 4,
    isLoading: false,
};
